/**
 * Public proposal page — client-side filters (current markup).
 */
(function () {
  'use strict';

  function boot() {
    var root = document.getElementById('nqProposalResults');
    if (!root || root.getAttribute('data-nq-proposal-bound') === '1') {
      return;
    }
    root.setAttribute('data-nq-proposal-bound', '1');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.nq-proposal-card'));
    var countEl = document.getElementById('nq_proposal_count');
    var emptyEl = document.getElementById('nq_proposal_empty_filter');

    function val(id) {
      var el = document.getElementById(id);
      return el ? String(el.value || '').trim() : '';
    }

    function apply() {
      var type = val('nq_pf_type');
      var loc = val('nq_pf_loc');
      var cabins = parseFloat(val('nq_pf_cabins') || '0') || 0;
      var length = parseFloat(val('nq_pf_length') || '0') || 0;
      var shown = 0;
      cards.forEach(function (card) {
        var ok = true;
        if (type && (card.getAttribute('data-type') || '') !== type) {
          ok = false;
        }
        if (loc && (card.getAttribute('data-location') || '') !== loc) {
          ok = false;
        }
        if (cabins > 0 && (parseFloat(card.getAttribute('data-cabins') || '0') || 0) < cabins) {
          ok = false;
        }
        if (length > 0 && (parseFloat(card.getAttribute('data-length') || '0') || 0) < length) {
          ok = false;
        }
        card.classList.toggle('d-none', !ok);
        if (ok) {
          shown += 1;
        }
      });
      if (countEl) {
        countEl.textContent = String(shown);
      }
      if (emptyEl) {
        emptyEl.classList.toggle('d-none', shown > 0 || cards.length === 0);
      }
    }

    ['nq_pf_type', 'nq_pf_loc', 'nq_pf_cabins', 'nq_pf_length'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) {
        return;
      }
      el.addEventListener('change', apply);
      el.addEventListener('input', apply);
    });
    var reset = document.getElementById('nq_pf_reset');
    if (reset) {
      reset.addEventListener('click', function () {
        ['nq_pf_type', 'nq_pf_loc', 'nq_pf_cabins', 'nq_pf_length'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) {
            el.value = '';
          }
        });
        apply();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
